const {
  encodeURIComponent,
  decodeURIComponent
} = window;

/**
 * Extracts url params
 * @param {String} url
 */
export const deparam = url => url.indexOf('?') === -1 ? {} : url.substr(url.indexOf('?') + 1)
  .split('&')
  .filter(Boolean)
  .map(str => str.split('=').map(decodeURIComponent))

  // keyValue instead of [key, value] to avoid a bunch of code to support destructuring
  // eslint-disable-next-line no-sequences
  .reduce((acc, keyValue) => (acc[keyValue[0]] = keyValue[1], acc), {});


/**
 * Converts key-value object to params string
 * @param {Object} params Key-value pairs
 * @return {String} paramified string. Empty if params has no enumerable props.
 */
export const param = params => Object.keys(params)
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
  .join('&') || '';

/**
 * Extracts full url up to /static
 * @param {String} url Script src.
 */
export const base = url => url.substr(0, url.indexOf('/static'));



// WEBPACK FOOTER //
// ./src/partners/embed/utils/url.js